import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// react-magnetic-di - temporary comment, for auto dependency injection in tests
import { useCallback } from 'react';
import { useIntl } from 'react-intl-next';
import { useRelayEnvironment } from 'react-relay';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireErrorAnalytics, fireOperationalEvent, fireTrackEvent } from '@atlassian/ui-modifications-analytics';
import { useExecutionContext } from '../../../../../../../controllers/execution-context';
import { useLookupFieldData } from '../../../../../../../controllers/hooks/use-lookup-field-data';
import { useViewType } from '../../../../../../../controllers/issue-adjustments/hooks/use-view-type';
import { useIssueAdjustmentsActions } from '../../../../../../../controllers/issue-adjustments/main';
import { UiModificationsValidationError } from '../../../../../../../controllers/issue-adjustments/utils/errors/ui-modifications-validation-error';
import { useTenantContext } from '../../../../../../../controllers/tenant-context';
import { getAnalytics } from '../../../../../../../controllers/view-configuration';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { moduleIncludesScreenTabsWriteScopes } from '../utils/filter-based-on-scopes/screen-tabs-data';
import { useFieldsChangesValidation } from './use-fields-changes-validation';
import { useFilterFieldChangesBasedOnScope } from './use-filter-fields-changes-based-on-scope';
export var useSubmit = function useSubmit(_ref) {
  var moduleScopes = _ref.moduleScopes,
    appId = _ref.appId;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var _useIssueAdjustmentsA = useIssueAdjustmentsActions(),
    updateFields = _useIssueAdjustmentsA.updateFields,
    setError = _useIssueAdjustmentsA.setError,
    unregisterFields = _useIssueAdjustmentsA.unregisterFields,
    setAppErrors = _useIssueAdjustmentsA.setAppErrors,
    updateScreenTabs = _useIssueAdjustmentsA.updateScreenTabs,
    detectAppliedChangesConflicts = _useIssueAdjustmentsA.detectAppliedChangesConflicts;
  var viewType = useViewType();
  var getAsyncLookupData = useLookupFieldData();
  var getFilteredFieldChangesBasedOnScope = useFilterFieldChangesBasedOnScope(moduleScopes);
  var tenantContext = useTenantContext();
  var executionContext = useExecutionContext();
  var environment = useRelayEnvironment();
  var getValidatedFieldsChanges = useFieldsChangesValidation();
  var intl = useIntl();
  return useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var fieldsChangesUnnormalized, screenTabsChanges, changeId, fieldsChanges, validatedFieldsChanges, lookupDataFromApi;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            fieldsChangesUnnormalized = _ref2.fieldsChanges, screenTabsChanges = _ref2.screenTabsChanges, changeId = _ref2.changeId;
            _context.prev = 1;
            fieldsChanges = getFilteredFieldChangesBasedOnScope(fieldsChangesUnnormalized);
            _context.next = 5;
            return getValidatedFieldsChanges(fieldsChanges);
          case 5:
            validatedFieldsChanges = _context.sent;
            _context.next = 8;
            return getAsyncLookupData(validatedFieldsChanges);
          case 8:
            lookupDataFromApi = _context.sent;
            _context.next = 11;
            return updateFields({
              changeId: changeId,
              fieldsChanges: fieldsChanges,
              // TODO: We should pass validatedFieldsChanges instead of fieldsChanges, UIM-2214
              lookupDataFromApi: lookupDataFromApi,
              tenantContext: tenantContext,
              executionContext: executionContext,
              environment: environment,
              appId: appId,
              intl: intl,
              createAnalyticsEvent: createAnalyticsEvent
            });
          case 11:
            if (screenTabsChanges && moduleIncludesScreenTabsWriteScopes(viewType, createAnalyticsEvent, moduleScopes, screenTabsChanges)) {
              updateScreenTabs({
                screenTabsChanges: screenTabsChanges,
                appId: appId,
                changeId: changeId
              });
            }
            detectAppliedChangesConflicts({
              appId: appId,
              changeId: changeId
            });
            getAnalytics(viewType).stopTTI({
              completionStatus: 'success',
              viewType: viewType
            });
            fireTrackEvent(createAnalyticsEvent, {
              action: 'success',
              actionSubject: "".concat(viewType, "jiraUiModificationsUseSubmit")
            });

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            _context.next = 26;
            break;
          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](1);
            setError({
              errorCode: 'USE_SUBMIT_ERROR_CODE'
            });
            getAnalytics(viewType).stopTTI({
              completionStatus: 'error',
              viewType: viewType
            });
            if (!(_context.t0 instanceof UiModificationsValidationError)) {
              _context.next = 25;
              break;
            }
            fireOperationalEvent(createAnalyticsEvent, {
              action: 'failed',
              actionSubject: 'jiraUiModifications.changesValidation',
              attributes: _objectSpread(_objectSpread({
                type: _context.t0.validationErrorType
              }, _context.t0.attributes), {}, {
                viewType: viewType
              })
            });

            // Setting app errors to pass them to the onErrorCallback
            setAppErrors({
              errors: _context.t0.attributes.errors,
              appId: appId
            });
            return _context.abrupt("return");
          case 25:
            fireErrorAnalytics({
              error: _context.t0,
              id: 'useSubmit',
              viewType: viewType,
              attributes: {
                errorCause: _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.cause
              },
              event: createAnalyticsEvent({})
            });
          case 26:
            _context.prev = 26;
            unregisterFields({
              changeId: changeId,
              appId: appId
            });
            return _context.finish(26);
          case 29:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 17, 26, 29]]);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [getFilteredFieldChangesBasedOnScope, getValidatedFieldsChanges, getAsyncLookupData, updateFields, tenantContext, executionContext, environment, appId, intl, viewType, createAnalyticsEvent, moduleScopes, updateScreenTabs, detectAppliedChangesConflicts, setError, setAppErrors, unregisterFields]);
};